import { Col, Row } from 'reactstrap';
import { ContentBlock } from "../Content/ContentBlock";
import { ContentBody } from "../Content/ContentBody";
import { ContentHeading } from "../Content/ContentHeading";
import { NavigationCard } from "./NavigationCard";

interface Props {
    PageData: any
}

interface FieldCardImage {
    alt: string
    url: string
    title: any
}

export interface NavigationCardData {
    id: string
    fieldCardTitle: string
    fieldCardLink: string
    fieldCardContent: string
    fieldCardImage?: FieldCardImage
}

export const NavigationCardSet = (props: Props) => {
    return (
        <ContentBlock className="navigationCardsContent">
            <ContentHeading title={props.PageData.fieldCardNavigationSectionTitle ?? ''} />
            <ContentBody>
                <div className="navigationCards">
                    <Row className="navCardRow">
                        {/* check if cards are set, loop through and display each card */}
                        {props.PageData.fieldNavigationCards?.length ? props.PageData.fieldNavigationCards.map((navigationCard: NavigationCardData) => {
                            return (
                                <Col key={navigationCard.id} className="card__wrap--inner">
                                    <NavigationCard cardData={navigationCard} />
                                </Col>
                            )
                        }) : <></>}
                    </Row>
                </div>
            </ContentBody>
        </ContentBlock>
    );
};
